function updateMinimalistStickyAtcPriceElements(context, variant, quantity = 1) {
  if (!context || !variant) return;

  const safeQuantity = Math.max(Number.parseInt(quantity, 10) || 1, 1);
  const totalPrice = variant.price * safeQuantity;
  const totalCompareAtPrice = variant.compare_at_price ? variant.compare_at_price * safeQuantity : null;
  const moneyFormat = FoxTheme.settings.moneyFormat;

  context.querySelectorAll('.f-price').forEach((priceWrapper) => {
    const salePrice = priceWrapper.querySelector('.f-price-item--sale');
    const regularPrices = priceWrapper.querySelectorAll('.f-price-item--regular');
    const saleValue = priceWrapper.querySelector('[data-sale-value]');
    const unitPriceWrapper = priceWrapper.querySelector('.f-price__unit-wrapper');
    const unitPrice = unitPriceWrapper?.querySelector('.f-price__unit');
    const isOnSale = totalCompareAtPrice && totalCompareAtPrice > totalPrice;

    priceWrapper.classList.toggle('f-price--on-sale', Boolean(isOnSale));
    priceWrapper.classList.toggle('f-price--sold-out', !variant.available);

    if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(totalPrice, moneyFormat);

    regularPrices.forEach((item) => {
      item.innerHTML = isOnSale
        ? `<s>${FoxTheme.Currency.formatMoney(totalCompareAtPrice, moneyFormat)}</s>`
        : FoxTheme.Currency.formatMoney(totalPrice, moneyFormat);
    });

    if (saleValue && isOnSale) {
      saleValue.textContent = `${Math.round(((totalCompareAtPrice - totalPrice) * 100) / totalCompareAtPrice)}%`;
    }

    if (variant.unit_price_measurement && unitPrice) {
      const measurement = variant.unit_price_measurement;
      const baseUnit = `${measurement.reference_value !== 1 ? measurement.reference_value : ''}${measurement.reference_unit}`;
      unitPriceWrapper.classList.remove('hidden');
      unitPrice.innerHTML = `<span>${FoxTheme.Currency.formatMoney(
        variant.unit_price,
        moneyFormat
      )}</span>/<span data-unit-price-base-unit>${baseUnit}</span>`;
    } else {
      unitPriceWrapper?.classList.add('hidden');
    }
  });
}

if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
        };
        this.onClickHandler = this.onClick.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleMainQuantityChange = this.handleMainQuantityChange.bind(this);
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('[type="submit"]'));
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.productRoot = this.dataset.productRootId
          ? document.getElementById(this.dataset.productRootId)
          : this.closest('product-info');
        this.productFormActions = this.productRoot?.querySelector('.main-product-form');
        this.mainProductInfo = this.productRoot;
        this.mainQuantityInput = this.productRoot?.querySelector(
          '.product-form__quantity quantity-input .quantity__input'
        );
        this.currentVariant = this.getCurrentVariant();

        this.submitEl?.addEventListener('click', this.onClickHandler);
        this.mainQuantityInput?.addEventListener('change', this.handleMainQuantityChange);

        this.init();
        this.updateTotalPrices();

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
        });
      }

      disconnectedCallback() {
        this.submitEl?.removeEventListener('click', this.onClickHandler);
        this.mainQuantityInput?.removeEventListener('change', this.handleMainQuantityChange);
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        this.initialized = false;
      }

      getCurrentVariant() {
        const variantId = Number(this.productRoot?.querySelector('.main-product-form [name="id"]')?.value);
        const variantDataElement = this.querySelector('[data-sticky-atc-variants]');

        if (variantDataElement) {
          try {
            const variants = JSON.parse(variantDataElement.textContent);
            return variants.find((variant) => variant.id === variantId) || variants[0] || null;
          } catch (error) {
            console.error('Unable to read product variants for sticky pricing.', error);
          }
        }

        return this.mainProductInfo?.currentVariant || null;
      }

      handleMainQuantityChange() {
        this.updateTotalPrices();
      }

      updateTotalPrices() {
        if (!this.currentVariant) return;

        const quantity = this.mainQuantityInput?.value || 1;
        this.updatePrice(this.currentVariant, this, quantity);
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty(
            '--mobile-sticky-bar-height',
            this.classList.contains(this.classes.isOpen) ? `${this.offsetHeight}px` : '0px'
          );
        });
      }
      init() {
        this.calculateHeight();
        if (!this.productFormActions) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle(this.classes.isOpen, isAboveViewport);
              document.documentElement.style.setProperty(
                '--mobile-sticky-bar-height',
                isAboveViewport ? `${this.offsetHeight}px` : '0px'
              );
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
      }

      onClick(event) {
        if (
          this.submitEl?.getAttribute('data-waitlist-trigger') === 'true' ||
          this.submitEl?.classList.contains('btn--waitlist')
        ) {
          return;
        }
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      scrollToTop(target, offset = 200) {
        if (!target) return;

        const scrollIntoView = (selector, offset) => {
          window.scrollTo({
            behavior: 'smooth',
            top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
          });
        };

        scrollIntoView(target, offset);
      }

      updateButton(disable = true, text, modifyClass = true, isWaitlist = false, waitlistAttributes = {}) {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('.btn__text') || addButton.querySelector('span');

        if (isWaitlist) {
          addButton.removeAttribute('disabled');
          addButton.setAttribute('type', 'button');
          addButton.setAttribute('data-waitlist-trigger', 'true');
          addButton.classList.add('btn--waitlist');

          if (waitlistAttributes.popupLink) {
            addButton.setAttribute('data-waitlist-popup-link', waitlistAttributes.popupLink);
          }
          if (waitlistAttributes.triggerSelector) {
            addButton.setAttribute('data-trigger-selector', waitlistAttributes.triggerSelector);
          }
          if (waitlistAttributes.modalId) {
            addButton.setAttribute('data-modal-id', waitlistAttributes.modalId);
          }
          if (waitlistAttributes.customJs) {
            addButton.setAttribute('data-custom-js', waitlistAttributes.customJs);
          }
          if (waitlistAttributes.variantId) {
            addButton.setAttribute('data-variant-id', waitlistAttributes.variantId);
          }
          if (waitlistAttributes.variantTitle) {
            addButton.setAttribute('data-variant-title', waitlistAttributes.variantTitle);
          }
          if (waitlistAttributes.productId) {
            addButton.setAttribute('data-product-id', waitlistAttributes.productId);
          }
          if (waitlistAttributes.productTitle) {
            addButton.setAttribute('data-product-title', waitlistAttributes.productTitle);
          }

          if (addButtonText) {
            addButtonText.textContent =
              text || waitlistAttributes.waitlistText || FoxTheme.variantStrings.joinWaitlist || 'ENTRAR NA LISTA DE ESPERA';
          }
        } else if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          addButton.setAttribute('type', 'submit');
          addButton.removeAttribute('data-waitlist-trigger');
          addButton.removeAttribute('data-waitlist-popup-link');
          addButton.removeAttribute('data-trigger-selector');
          addButton.removeAttribute('data-modal-id');
          addButton.removeAttribute('data-custom-js');
          addButton.classList.remove('btn--waitlist');
          if (text && addButtonText) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButton.setAttribute('type', 'submit');
          addButton.removeAttribute('data-waitlist-trigger');
          addButton.removeAttribute('data-waitlist-popup-link');
          addButton.removeAttribute('data-trigger-selector');
          addButton.removeAttribute('data-modal-id');
          addButton.removeAttribute('data-custom-js');
          addButton.classList.remove('btn--waitlist');
          if (addButtonText) addButtonText.textContent = FoxTheme.variantStrings.addToCartShort || FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice(variant, context = this, quantity = 1) {
        updateMinimalistStickyAtcPriceElements(context, variant, quantity);
      }

      syncWithMainProductForm() {
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange
        );
      }

      handleVariantChange(event) {
        const isMainProduct = event?.data?.sectionId === this.mainProductInfo?.dataset.section;
        if (!isMainProduct) return;
        const variant = event.data.variant;
        const html = event.data.html;
        this.currentVariant = variant;
        if (variant) this.updateTotalPrices();

        const sectionId = this.mainProductInfo?.dataset.section;
        const mainSubmitBtn =
          html?.getElementById?.(`ProductSubmitButton-${sectionId}`) ||
          document.getElementById(`ProductSubmitButton-${sectionId}`);

        const currentBtn = this.querySelector('[name="add"]');
        const mainForm = this.mainProductInfo?.querySelector('.product-form');

        const isSoldOutOrUnavailable = !variant || variant.available === false;
        const isWaitlistFromMain = mainSubmitBtn?.getAttribute('data-waitlist-trigger') === 'true';
        const isWaitlistEnabled =
          isWaitlistFromMain ||
          this.getAttribute('data-enable-waitlist') === 'true' ||
          mainForm?.getAttribute('data-enable-waitlist') === 'true' ||
          mainSubmitBtn?.getAttribute('data-waitlist-configured') === 'true' ||
          currentBtn?.getAttribute('data-waitlist-configured') === 'true';

        const isWaitlist = isSoldOutOrUnavailable && isWaitlistEnabled;

        const defaultPopupLink =
          this.getAttribute('data-default-waitlist-popup-link') ||
          mainForm?.getAttribute('data-default-waitlist-popup-link') ||
          mainSubmitBtn?.getAttribute('data-default-waitlist-popup-link') ||
          currentBtn?.getAttribute('data-default-waitlist-popup-link') ||
          '';

        const defaultWaitlistText =
          this.getAttribute('data-default-waitlist-text') ||
          mainForm?.getAttribute('data-default-waitlist-text') ||
          mainSubmitBtn?.getAttribute('data-default-waitlist-text') ||
          (isWaitlistFromMain ? mainSubmitBtn?.querySelector('.btn__text')?.textContent?.trim() : null) ||
          currentBtn?.getAttribute('data-default-waitlist-text') ||
          FoxTheme.variantStrings.joinWaitlist ||
          'ENTRAR NA LISTA DE ESPERA';

        const defaultModalId =
          this.getAttribute('data-default-waitlist-modal-id') ||
          mainForm?.getAttribute('data-default-waitlist-modal-id') ||
          mainSubmitBtn?.getAttribute('data-default-modal-id') ||
          currentBtn?.getAttribute('data-default-modal-id') ||
          '';

        const defaultCustomJs =
          this.getAttribute('data-default-waitlist-custom-js') ||
          mainForm?.getAttribute('data-default-waitlist-custom-js') ||
          mainSubmitBtn?.getAttribute('data-default-custom-js') ||
          currentBtn?.getAttribute('data-default-custom-js') ||
          '';

        const waitlistAttributes = isWaitlist
          ? {
              triggerSelector:
                mainSubmitBtn?.getAttribute('data-trigger-selector') ||
                currentBtn?.getAttribute('data-trigger-selector') ||
                defaultPopupLink,
              popupLink:
                mainSubmitBtn?.getAttribute('data-waitlist-popup-link') ||
                currentBtn?.getAttribute('data-waitlist-popup-link') ||
                defaultPopupLink,
              modalId:
                mainSubmitBtn?.getAttribute('data-modal-id') ||
                currentBtn?.getAttribute('data-modal-id') ||
                defaultModalId,
              customJs:
                mainSubmitBtn?.getAttribute('data-custom-js') ||
                currentBtn?.getAttribute('data-custom-js') ||
                defaultCustomJs,
              variantId: variant?.id || '',
              variantTitle: variant?.title || '',
              productId: this.dataset.productId || mainSubmitBtn?.getAttribute('data-product-id') || '',
              productTitle:
                mainSubmitBtn?.getAttribute('data-product-title') ||
                document.querySelector('.product__title')?.textContent?.trim() ||
                '',
              waitlistText: defaultWaitlistText,
            }
          : {};

        if (isWaitlist) {
          this.updateButton(false, defaultWaitlistText, true, true, waitlistAttributes);
          return;
        }

        if (!variant) {
          this.updateButton(true, FoxTheme.variantStrings.unavailable, true, false);
          return;
        }

        if (!variant.available) {
          this.updateButton(true, FoxTheme.variantStrings.soldOut, true, false);
          return;
        }

        this.updateButton(false, FoxTheme.variantStrings.addToCartShort || FoxTheme.variantStrings.addToCart, true, false);
      }
    }
  );
}
